import { Injector, TemplateRef } from '@angular/core';
import { Injectable } from '@angular/core';

import { ComponentPortal } from 'app/ui/core/portal';
import { ComponentType } from 'app/ui/core/portal';
import { Overlay } from 'app/ui/core/overlay';
import { OverlayRef } from 'app/ui/core/overlay-ref';
import { UILensComponent } from './lens.component';
import { TemplatePortal } from 'app/ui/core/portal';

@Injectable()
export class UILensService {

    private _overlayRef: OverlayRef;

    constructor(private _injector: Injector, private _overlay: Overlay) {
    }

    open<T>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, beaconName: string): void {
        this._destroyLens();
        this._overlayRef = this._createOverlay();
        const lensContainer = this._attachLensContainerComponent(beaconName);
        this._attachLensContent(componentOrTemplateRef, lensContainer);
    }

    close(): void {
        this._destroyLens();
    }

    private _destroyLens() {
        if (this._overlayRef) {
            this._overlayRef.detachBackdrop();
            this._overlayRef.dispose();
            this._overlayRef = null;
        }
    }

    private _createOverlay(): OverlayRef {
        return this._overlay.create({
            backdropClass: 'cdk-overlay-gray-backdrop',
            hasBackdrop: true
        });
    }

    private _attachLensContent<T>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, lensContainer: UILensComponent): void {
        if (componentOrTemplateRef instanceof TemplateRef) {
            lensContainer.attachTemplatePortal(new TemplatePortal(componentOrTemplateRef, null));
        } else {
            lensContainer.attachComponentPortal(new ComponentPortal(componentOrTemplateRef, null, this._injector));
        }
    }

    private _attachLensContainerComponent(beaconName: string): UILensComponent {
        const component = this._overlayRef.attach(new ComponentPortal(UILensComponent, null)).instance;
        component.beaconName = beaconName;
        return component;
    }

}